import mountVues from "@galaxy/modules/Core/resources/js/mountVues";

common.View.create('admin::layouts.main.LanguageSwitcher', {

    fieldChanges: false,

    /**
     * Called when DOM is ready.
     */
    onDOMLoad()
    {
        setTimeout(() => {
            this.initLanguage();

            this.element.find('a')
                .on('click', async (event) => {
                    let confirmation = { isConfirmed: false };

                    if( this.fieldChanges ) {
                        event.preventDefault();

                        confirmation = await Swal.fire({
                            title: 'Weet u het zeker? U heeft nog niet opgeslagen aanpassingen.',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Ja',
                            confirmButtonColor: '#62de43',
                            cancelButtonText: 'Annuleren',
                        });
                    }

                    if( confirmation.isConfirmed ) {
                        this.initLanguage($(event.currentTarget).data('language') || '');

                        if( this.fieldChanges ) {
                            window.location.href = $(event.currentTarget).attr('href');
                        }
                    }
                })
        }, 1);
    },

    initLanguage(currentLang)
    {
        if( !currentLang && currentLang !== '' ) {
            // Get search parameters
            let searchParams = new URLSearchParams(window.location.search)
            currentLang = searchParams.get('language');
        }

        // Set default language if no language is given in url
        // TODO Medium: Get fallback language from config - will not always be NL;
        if (currentLang == null && currentLang !== '')
            currentLang = $('.langSwitch').data('default') || $('html').attr('lang');

        // Trigger flag icon and language change
        this.changeFlagIcon(currentLang);
        this.changeLanguage(currentLang);

        // On any input change; we check re-render the language since it may have something to do with the language fields
        $('input,textarea,select').on('change', (event) => {
            this.fieldChanges = true;
            this.changeLanguage(currentLang);
        });

        $('button[type="button"]').on('click', (event) => {
            this.changeLanguage(currentLang);
        });
    },

    // Trigger language
    changeFlagIcon(currentLang)
    {
        // Get relevant dropdown item by hash.
        let dropdownItem = this.element.find('a[href$="language=' + currentLang + '"]') || this.element.find('a:first-child');

        // Update icon if language is found.
        if( dropdownItem )
            this.element.find('button i').replaceWith( dropdownItem.find('i').clone() );
    },

    changeLanguage(currentLang)
    {
        // Get all language Fields
        let $langFields = $('*[data-lang]');

        $langFields.each(function (index, value)
        {
            // Check if language field shave current (SET) language
            if( $(value).data('lang') == currentLang)
                $(value).show().attr('hidden', false);
            else
                $(value).hide().attr('hidden', true);

            // If language is empty; show as well
            if( $(value).data('lang') === '' || currentLang === '' )
                $(value).show().attr('hidden', false);
        });

        // Change in canvas editors.
        $('.galaxy\\:\\:common-canvas-Editor:not(.view)')
            .each((i, element) =>
            {
                // Get Vue instance.
                let vueInstance = $(element).data('vueInstance');

                // Set new language. Reactivity will trigger update.
                vueInstance.currentLanguage = currentLang;
            })
    }

});
